import { z } from 'zod/v4';

import {
  companyTypeOptions,
  companyTypeSchema,
} from '../../../schemas/company-type.schema';
import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';
import { fleetCloudProviderSchema } from './fleet-cloud-provider.schema';

export const fleetOnlyAccountSchema = z.object({
  accountId: z.number(),
  accountName: z.string(),
  accountType: createEnumSchemaPreprocessor(
    companyTypeSchema.nullable(),
    companyTypeOptions
  ),
  cloudProvider: fleetCloudProviderSchema,
});

export type FleetOnlyAccount = z.infer<typeof fleetOnlyAccountSchema>;
